import { render, staticRenderFns } from "./KeywordCustom.vue?vue&type=template&id=22d213d1&"
import script from "./KeywordCustom.vue?vue&type=script&lang=js&"
export * from "./KeywordCustom.vue?vue&type=script&lang=js&"
import style0 from "./KeywordCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports